import { combineReducers } from 'redux';

import { metadataReducer, MetadataState } from 'store/booking/metadata/reducer';
import { appointmentReducer, AppointmentState } from './appointment/reducers';
import appointmentsReducer, { AppointmentsState } from './appointments/reducers';
import patientInsuranceReducer, { PatientInsuranceState } from './patientInsurance/reducers';
import specialtiesReducer, { SpecialtiesState } from './specialties/reducers';

export interface BookingState {
  metadata: MetadataState;
  appointment: AppointmentState;
  appointments: AppointmentsState;
  patientInsurance: PatientInsuranceState;
  specialties: SpecialtiesState;
}

export default combineReducers({
  metadata: metadataReducer,
  appointment: appointmentReducer,
  appointments: appointmentsReducer,
  patientInsurance: patientInsuranceReducer,
  specialties: specialtiesReducer
});
